import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles, Popover, List, ListItem, ListItemAvatar, ListItemText } from "@material-ui/core";
import NotificationBell from './../Utilities/NotificationBell/NotificationBell';
import { Scrollbars } from "react-custom-scrollbars";
import ActionCreator from './../../store/actions/index';
import { notArrayOrEmpty } from "../../utils/helpers";
import guid from './../../utils/guid';
import WelcomeDialog from "../Utilities/WelcomeDialog";
import MarkunreadIcon from '@material-ui/icons/Markunread';
import DraftsIcon from '@material-ui/icons/Drafts';
import { themeTypeToBool } from './../../utils/helpers';

const useStyles = theme => ({
    list: {
        maxHeight: 250,
        overflow: 'overlay',
        maxWidth: 250
    },
    listItem: {
        opacity: 0.8,
        marginTop: 2,
        "&:hover": {
            opacity: 1
        }
    },
    secondaryText: {
        color: themeTypeToBool(theme.palette.type) ? "#131313" : "#FAFAFA"
    }
});

const trimString = str => {
    return str.length > 10 ? str.substring(0, 23) + "..." : str;
};

const UserNotifications = (props) => {
    const { notifications, theme, classes } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [showNotification, setShowNotification] = useState(null);

    useEffect(() => {
        let interval;
        interval = setInterval(props.fetchNotifications, 30000);
        props.fetchNotifications();
        return () => {
            clearInterval(interval);
        };
    }, []);

    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const handleDialogClose = () => {
        props.changeWelcomeDialogState(false);
        if(showNotification.nowe)
            props.readNotification(showNotification.powiadomienia_id);
        setShowNotification(null);
    };

    const printNotifications = data => {
        if (notArrayOrEmpty(data))
            return;
        data = data.sort((a, b) => b.czas_dodania - a.czas_dodania);
        return data.map((row) => (
            <ListItem
                key={guid()}
                button
                className={classes.listItem}
                style={{ background: row.nowe && theme.palette.primary.main }}
                onClick={() => setShowNotification(row)}
            >
                <ListItemAvatar>
                    {row.nowe ? <MarkunreadIcon /> : <DraftsIcon />}
                </ListItemAvatar>
                <ListItemText
                    primary={row.tytul}
                    secondary={trimString(row.tresc)}
                    classes={{secondary: classes.secondaryText}}
                />
            </ListItem>
        ));
    };

    const getUnreadNotifications = data => data.filter(notification => notification.nowe === true).length;

    return (
        <React.Fragment>
            <NotificationBell notificationCount={getUnreadNotifications(notifications)} onClick={handleClick} />
            <Popover
                open={anchorEl !== null}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <List className={classes.list}>
                    <Scrollbars
                        autoHeight
                    >
                        {printNotifications(notifications)}
                    </Scrollbars>
                </List>
            </Popover>
            {
                showNotification !== null
                &&
                <WelcomeDialog
                    open={showNotification !== null}
                    onClose={handleDialogClose}
                    data={showNotification}
                />
            }
        </React.Fragment>
    );
};

const mapStateToProps = (state) => ({
    notifications: state.requestReducer.notifications,
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};


UserNotifications.propTypes = {
    classes: PropTypes.object,
    theme: PropTypes.object,
    //redux
    notifications: PropTypes.array,
    welcomeDialog: PropTypes.bool,
    changeWelcomeDialogState: PropTypes.func,
    fetchNotifications: PropTypes.func,
    readNotification: PropTypes.func
};

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    withStyles(useStyles, { withTheme: true })
)(UserNotifications);
